import styled from 'styled-components';
import Select from '@material-ui/core/Select';
import Tabs from '@material-ui/core/Tabs';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const SelectStyled = styled(Select)`
  text-align: left;
`;

export const SecondaryTabs = styled(Tabs)`
  min-height: 43px;
  height: 43px;

  .MuiTabs-indicator {
    display: flex;
    border-radius: 0px 93px 0px 0px;
  }

  .MuiTabs-flexContainer {
    justify-content: flex-start;
    flex-wrap: nowrap;
  }

  .MuiTab-wrapper {
    white-space: nowrap;
    font-size: 1.4rem;
    line-height: 1em;
  }

  .MuiTab-root {
    margin: 0;
    background-color: transparent !important;
    padding: 0 15px;
    display: flex;
    justify-content: center;
  }

  ${breakpoints.up('md')} {
    min-height: 48px;
    height: 48px;

    .MuiTab-wrapper {
      font-size: 2rem;
      line-height: 1em;
      font-weight: 500;
    }

    .Mui-selected {
      .MuiTab-wrapper {
        font-weight: 600;
      }
    }
  }
`;

export default SelectStyled;
